export class VersionesTable {
  public static versiones: any = [
  {id:1,"numero":"2021.1.1.0",observacion:"abajo"},
  {id:2,"numero":"2020.1.1.0",observacion:"Otcom"}
  ]
}
